import './PriceCard.scss';
import React from 'react';
import { useState } from 'react';

function PriceCard({capture,priceData,total,classname}) {
    let priceDataItem = priceData.map((item,index) =>(
        <div className='price-item' key={index}>{item}</div> 
    ))

  return (
    <div  className={`${"price-card"} ${classname} `} >
        <div className="price-card-content">
            <div className="price-item-capture">
                {capture}
            </div>
            <div className="price-data">
                {priceDataItem}
            </div>
            <div className="total">
                {total}
            </div>
        </div>
    </div>
  );
}

export default PriceCard;